import { queryClient } from "../../lib/queryClient";
import { queryKeys } from "../../lib/queryKeys";
import {
  getProviderDetails,
  getStatusList,
  getTopicList,
} from "../../services";

export const prefetchStatusList = () =>
  queryClient.prefetchQuery({
    queryKey: queryKeys.statusList(),
    queryFn: () => getStatusList(),
    staleTime: 5 * 60 * 1000,
  });

export const prefetchTopicList = () =>
  queryClient.prefetchQuery({
    queryKey: queryKeys.topicList(),
    queryFn: () => getTopicList(),
    staleTime: 5 * 60 * 1000,
  });

export const prefetchProviderDetails = (providerNpi: string) =>
  queryClient.prefetchQuery({
    queryKey: queryKeys.providerDetails(providerNpi),
    queryFn: () => getProviderDetails({ provider_npi: providerNpi }),
    staleTime: 5 * 60 * 1000,
  });

export const prefetchCdiReferenceData = () => {
  void prefetchStatusList().catch((error) => {
    console.error("Failed to prefetch status list:", error);
  });
  void prefetchTopicList().catch((error) => {
    console.error("Failed to prefetch topic list:", error);
  });
};

/** @deprecated Use prefetchCdiReferenceData */
export const prefetchArcplusReferenceData = prefetchCdiReferenceData;

export const prefetchHomeReferenceData = (providerNpi?: string) => {
  prefetchCdiReferenceData();

  if (providerNpi) {
    void prefetchProviderDetails(providerNpi).catch((error) => {
      console.error("Failed to prefetch provider details:", error);
    });
  }
};

/** Force a fresh care-management fetch the next time a CAiRE tab mounts. */
export const invalidateCareManagementQuery = () =>
  queryClient.invalidateQueries({ queryKey: ["careManagementQuery"] });
